<template>
  <div class="header">
    <p class="header-logo">
      <router-link :to="{ name: '學員報到' }">
        <img src="~@/assets/img/svg/logo.svg" alt="" />
      </router-link>
    </p>
    <ul class="header-menu">
      <li>
        <router-link :to="{ name: '學員報到' }">
          學員報到
        </router-link>
      </li>
    </ul>

    <div class="header-user">
      <p>登出</p>
      <a href="#" @click.prevent="$bvModal.show('member-logout')">
        <span class="icon-icon_longout"></span>
      </a>
    </div>
    <MemberLogout />
  </div>
</template>

<script>
import MemberLogout from '@/components/Modal/MemberLogout';

export default {
  components: {
    MemberLogout
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss"></style>
